<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id === selected"
      >{{ status.size }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectCustomerSizes',
  data() {
    return {
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/customer/size/all`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
